export default function About() {
  return (
    <section id="about" className="py-20 px-6 bg-white">
      <div className="max-w-6xl mx-auto">
        <div className="flex flex-col lg:flex-row items-center gap-12">
          {/* Image */}
          <div className="w-full lg:w-[420px] flex-shrink-0">
            <div className="w-full h-[340px] lg:h-[420px] overflow-hidden rounded-lg border-l-4 border-texas-red">
              <img
                src="https://images.unsplash.com/photo-1575405805195-695291eb22de?crop=entropy&cs=tinysrgb&fit=max&ixid=M3w3Mzk3NjZ8MHwxfHNlYXJjaHw1fHxUZXhhc3xlbnwwfHx8fDE3NzU0MjU5MDR8MA&ixlib=rb-4.1.0&w=1080&auto=format"
                alt="Texas longhorn cattle"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>

          {/* Text */}
          <div className="flex-1">
            <span className="text-texas-red text-xs font-bold tracking-widest uppercase mb-3 block">Who We Are</span>
            <h2 className="text-3xl md:text-4xl font-bold text-texas-navy mb-6 leading-snug">
              About Texas Consultancy<br className="hidden md:block" /> and Sales Agency
            </h2>
            <p className="text-gray-600 text-base leading-relaxed mb-5">
              Texas Consultancy and Sales Agency is dedicated to empowering small to mid-sized businesses with revenues between $5 million and $75 million. We specialize in providing expert guidance at the C-suite level, helping business leaders navigate complex turnarounds, enhance profitability, and position their companies for strategic growth. Our deep industry expertise and proven methodologies have helped countless businesses achieve their most ambitious goals.
            </p>
            <p className="text-gray-600 text-base leading-relaxed mb-8">
              We offer comprehensive consulting across all critical business functions—from executive leadership and organizational strategy to operations and supply chain management. Whether you're looking to optimize your current operations, prepare for a strategic sale to private equity or venture capital firms, or transform your business model, our team of seasoned consultants brings the strategic insight and practical experience needed to drive meaningful, measurable results.
            </p>
            <a
              href="#contact"
              className="inline-block bg-texas-red hover:bg-texas-red-dark text-white text-sm font-semibold px-7 py-3 rounded-md transition-colors duration-200 cursor-pointer whitespace-nowrap"
            >
              Talk to Our Team
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
